module.exports = __webpack_public_path__ + "4912d49f09229bd235ae54c2bd4c0a2a.jpg";